import { useLanguage } from '../../../context/LanguageContext';

export default function WhyUs() {
  const { t } = useLanguage();

  const reasons = [
    {
      icon: 'ri-share-line',
      title: t('whyUs.reason1Title'),
      description: t('whyUs.reason1Description'),
    },
    {
      icon: 'ri-compass-3-line',
      title: t('whyUs.reason2Title'),
      description: t('whyUs.reason2Description'),
    },
    {
      icon: 'ri-hand-heart-line',
      title: t('whyUs.reason3Title'),
      description: t('whyUs.reason3Description'),
    },
    {
      icon: 'ri-user-star-line',
      title: t('whyUs.reason4Title'),
      description: t('whyUs.reason4Description'),
    },
  ];

  return (
    <section id="why-us" className="py-32 bg-[#1A2B4A] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-2 h-2 rounded-full bg-white"></div>
        <div className="absolute top-40 right-20 w-2 h-2 rounded-full bg-white"></div>
        <div className="absolute bottom-32 left-1/4 w-2 h-2 rounded-full bg-white"></div>
        <div className="absolute bottom-20 right-1/3 w-2 h-2 rounded-full bg-white"></div>
        <div className="absolute top-1/2 left-1/2 w-2 h-2 rounded-full bg-white"></div>
        <div className="absolute top-1/3 right-1/4 w-2 h-2 rounded-full bg-white"></div>
      </div>

      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="text-center mb-20">
          <div className="w-16 h-0.5 bg-[#C9A961] mx-auto mb-6"></div>
          <h2 className="text-5xl font-serif font-bold text-white mb-6">{t('whyUs.heading')}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {reasons.map((reason, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 border-2 border-[#C9A961] rounded-lg flex items-center justify-center mx-auto mb-8">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-5">{reason.title}</h3>
              <p className="text-white/70 leading-relaxed max-w-xs mx-auto">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}